import * as Yup from 'yup';

export const examValidationSchema = Yup.object()
  .shape({
    name: Yup.string()
      .min(3, 'Exam name must be of minimum 3 characters length')
      .max(500, 'Exam name must be between 3 and 500 characters')
      .required('Please enter the exam name here')
      .matches(
        /^[A-Za-z0-9_-\s]+$/,
        'Exam name can only include letters, numbers, and the following characters: - _'
      ),
    start: Yup.date().typeError('Please enter a valid date').nullable(),
    end: Yup.date()
      .typeError('Please enter a valid date')
      .nullable()
      .required('Please enter End Date'),
    url: Yup.string().url('Invalid Exam URL').required('Please enter Exam URL'),
    password: Yup.string().nullable(),
    proctoringOption: Yup.string().required('Please enter the Proctoring Type'),
    secureBrowserSettings: Yup.object().shape({
      enabled: Yup.boolean(),
      disableNavigation: Yup.boolean(),
      disablePrintScreen: Yup.boolean(),
      disableCopyPaste: Yup.boolean(),
      forceFullScreen: Yup.boolean(),
      enableWhitelistedUrls: Yup.boolean(),
      whitelistedUrls: Yup.string().nullable(),
    }),
  })
  .test(
    'secure-browser-required-for-secure-browser-only',
    'Secure Browser Required must be enabled for Secure Browser Only (No Proctoring)',
    (values) => {
      if (!values) {
        return true;
      }
      if (values.proctoringOption !== 'SECURE_BROWSER_ONLY_NO_PROCTORING') {
        return true;
      }
      return Boolean(values.secureBrowserSettings?.enabled);
    }
  );
